import { Row } from "@tanstack/react-table";

export function dateRangeFilter<T>(
  row: Row<T>,
  columnId: string,
  [from, to]: [string, string],
) {
  let cellValue = new Date(row.getValue(columnId));
  if (cellValue === undefined) return false;

  let fromDate = from ? new Date(`${from} 00:00:00`) : undefined;
  let toDate = to ? new Date(`${to} 00:00:00`) : undefined;

  // if from is defined, and to is not...
  // we want dates greater than from
  if (fromDate && !toDate) {
    return cellValue >= fromDate;
  }

  // if toDate is defined, and fromDate is not...
  // we wants dates less than toDate
  if (toDate && !fromDate) {
    return cellValue <= toDate;
  }

  if (fromDate && toDate) {
    // if fromDate and toDate are both defined, and fromDate > toDate, swap them.
    if (fromDate > toDate) {
      [fromDate, toDate] = [toDate, fromDate];
    }

    return cellValue >= fromDate && cellValue <= toDate;
  }

  return true;
}
